<template>
  <div class="page-education-column-activity-list"
       v-infinite-scroll="fetchData"
       infinite-scroll-disabled="loading"
       infinite-scroll-distance="50"
  >
    <component :is="currentView"
               :list="list"
               :hint="render.clickNoticeHint"
    />
  </div>
</template>

<script>
  import NoticeActivityList from '@/pages/EducationColumn/components/NoticeActivityList';
  import ReviewActivityList from '@/pages/EducationColumn/components/ReviewActivityList';
  import { getActivityList } from '@/services/education-column';
  import { LIMIT } from '@/utils/constant';
  import { upperCaseFirst } from '@/utils';

  export default {
    name: 'PageEducationColumnNoticeActivityList',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      NoticeActivityList,
      ReviewActivityList,
    },
    data() {
      return {
        loading: false,
        allLoad: false,
        start: 0,
        list: [],
        render: {
          pageTitle: '',
          clickNoticeHint: '',
        },
      };
    },
    computed: {
      type() {
        const { $route } = this;
        const { params } = $route;
        return params.type;
      },
      currentView() {
        return `${upperCaseFirst(this.type)}ActivityList`;
      },
    },
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.allLoad) return;

        this.loading = true;

        const { type, start } = this;
        const data = await getActivityList({
          type,
          start,
          limit: LIMIT,
        }, isLoadMore);

        this.render = data.render;

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }

        this.start = data.start;
        this.list = [...this.list, ...data.list];

        this.loading = false;
      },
    },
    created() {
      this.fetchData(false);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-education-column-activity-list {
    padding-top: @size-base;
  }
</style>
